import { render } from "./WebViewerROC.vue?vue&type=template&id=24a40002"
import script from "./WebViewerROC.vue?vue&type=script&lang=js"
export * from "./WebViewerROC.vue?vue&type=script&lang=js"

import "./WebViewerROC.vue?vue&type=style&index=0&id=24a40002&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__